// src/components/PausedProfileBanner.js
import React, { useState } from 'react';
import { AlertCircle } from 'lucide-react';

const PausedProfileBanner = ({ onReactivate }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleConfirmReactivate = () => {
    setShowConfirmModal(false);
    onReactivate();
  };

  return (
    <>
      <div className="bg-red-50 border-b border-red-300 px-4 py-2.5 relative z-40">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <AlertCircle className="w-4 h-4 text-red-600 flex-shrink-0" />
            <p className="text-sm font-semibold text-red-900 truncate">
              YOUR PROFILE IS PAUSED
              <span className="font-normal text-red-800 ml-2 hidden sm:inline">
                - You're not receiving new bookings
              </span>
            </p>
          </div>
          <button
            onClick={() => setShowConfirmModal(true)}
            className="px-3 py-1.5 bg-red-600 text-white text-xs font-semibold rounded-md hover:bg-red-700 transition-colors whitespace-nowrap flex-shrink-0"
          >
            Reactivate
          </button>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-sm w-full p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-3">
              Reactivate Your Profile?
            </h3>

            <p className="text-sm text-gray-700 mb-6">
              Your profile will be visible in search and you'll start receiving new bookings again.
            </p>

            <div className="flex gap-3">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmReactivate}
                className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition-colors"
              >
                Yes, Reactivate
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PausedProfileBanner;
